import React from 'react'
import PropTypes from 'prop-types'

import { TextField, CircularProgress } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'

import useFetch from 'hooks/useFetch'
import useDebounce from 'hooks/useDebounce'

const InputAutocomplete = ({
  fn,
  fnLabel,
  entity,
  keyEntity,
  searchParam,
  onChange,
  fixedFilter = {},
  textFieldProps = {},
  ...rest
}) => {
  const [open, setOpen] = React.useState(false)
  const [value, setValue] = React.useState()
  const [debounceValue, setDebounceValue] = React.useState('')

  const { response, isLoading, refresh } = useFetch(fn, {
    [searchParam]: debounceValue,
    ...fixedFilter,
  })

  useDebounce(debounceValue, () => refresh(), 250)

  React.useEffect(() => {
    if (!value || !rest.value) {
      setValue(rest.value)
      return
    }

    if (rest.value && value[keyEntity] !== rest.value[keyEntity]) {
      setValue(rest.value)
    }

  /* eslint-disable react-hooks/exhaustive-deps */
  }, [rest.value])

  const handleOpen = () => {
    setDebounceValue('')
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleKeyUp = event => {
    if (event.target.value === debounceValue) {
      return
    }

    setDebounceValue(event.target.value)
  }

  const handleChange = (event, value) => {
    setValue(value)
    onChange({ target: { name: rest.name, value } })
  }

  const optionSelected = (option, value) => {
    return option[keyEntity] === value[keyEntity]
  }

  return (
    <Autocomplete
      open={open}
      loading={isLoading}
      options={response ? response.data[entity] : []}
      onOpen={handleOpen}
      onClose={handleClose}
      value={value}
      onKeyUp={handleKeyUp}
      onChange={handleChange}
      getOptionLabel={fnLabel}
      getOptionSelected={optionSelected}
      openText="Abrir"
      closeText="Fechar"
      noOptionsText="Nenhuma opção encontrada"
      loadingText="Carregando..."
      renderInput={params => (
        <TextField
          {...params}
          {...textFieldProps}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      {...rest}
    />
  )
}

InputAutocomplete.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  fn: PropTypes.func.isRequired,
  fnLabel: PropTypes.func.isRequired,
  entity: PropTypes.string.isRequired,
  keyEntity: PropTypes.string.isRequired,
  searchParam: PropTypes.string.isRequired,
  fixedFilter: PropTypes.object,
  textFieldProps: PropTypes.object,
}

export default InputAutocomplete
